import React, { Component } from "react";
import { invokeApig } from '../../libs/awsLib';
import { Glyphicon, Button, ListGroupItem, ListGroup } from "react-bootstrap";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceArea, Brush,
	RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar } from 'recharts';

const colors = ['#ff0000', '#00ff00', '#0000ff'];

export default class CompareUnits extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            isLoadingEventSec: false,
            units: props.units,
            startDate: props.startDate,
            endDate: props.endDate,
            data: [],
            left: 'dataMin',
            right: 'dataMax',
            refAreaLeft: '',
            refAreaRight: '',
            top: 'dataMax+1',
            bottom: 'dataMin-1',
            top2: 'dataMax+20',
            bottom2: 'dataMin-20'
        };
    }
    componentDidMount() {
        this.updateCompare({});
    }

    async updateCompare() {
    	try {
        	const results = await invokeApig({
                path: "/trip/summarychart1",
                method: "POST",
                body: {
                	"units": this.state.units,
                    "startDate": this.state.startDate,
                    "endDate": this.state.endDate
                }
            });
        	this.setState({ data: results, isLoading: false });
        } catch (e) {
        	alert(e);
        	this.setState({ isLoading: false });
        }
    }
    
    getAxisYDomain = (from, to, ref, offset) => {
    	const refData = this.state.data.slice(from-1, to);
    	let [ bottom, top ] = [ refData[0][ref], refData[0][ref] ];
    	refData.forEach( d => {
    		if ( d[ref] > top ) top = d[ref];
    		if ( d[ref] < bottom ) bottom = d[ref];
    	});
    	return [ (bottom|0) - offset, (top|0) + offset ]
    };

    zoom = () => {
    	let { refAreaLeft, refAreaRight, data } = this.state;
    	if ( refAreaLeft === refAreaRight || refAreaRight === '' ) {
    		this.setState( () => ({
    			refAreaLeft : '',
    			refAreaRight : ''
    		}) );
    		return;
    	}
    	// xAxis domain
    	if ( refAreaLeft > refAreaRight ) {
    		[ refAreaLeft, refAreaRight ] = [ refAreaRight, refAreaLeft ];
    	}
    	// yAxis domain
    	const [ bottom, top ] = this.getAxisYDomain( refAreaLeft, refAreaRight, 'val1', 1 );
    	const [ bottom2, top2 ] = this.getAxisYDomain( refAreaLeft, refAreaRight, 'val2', 50 );
        this.setState( () => ({
          refAreaLeft : '',
          refAreaRight : '',
          data : data.slice(),
          left : refAreaLeft,
          right : refAreaRight,
          bottom, top, bottom2, top2
        } ) );
    };

    zoomOut = () => {
      	const { data } = this.state;
      	this.setState( () => ({
          data : data.slice(),
          refAreaLeft : '',
          refAreaRight : '',
          left : 'dataMin',
          right : 'dataMax',
          top : 'dataMax+1',
          bottom : 'dataMin',
          top2 : 'dataMax+50',
          bottom2: 'dataMin+50'
        }) );
    }
    renderSecChart() {
	  const { data, left, right, refAreaLeft, refAreaRight, top, bottom } = this.state;
  	  let i = 0;
  	  return (
  		<div>
    	<p>Evolución en seguridad</p>
		<Button onClick={this.zoomOut}>Zoom original</Button>
		{
			this.state.isLoading ?
			<div><Glyphicon glyph="refresh" className="spinning" />Cargando datos... por favor espere</div>
			:
			(
			this.state.data.length ?
			<LineChart width={800} height={400} data={data}
	          onMouseDown = { (e) => this.setState({refAreaLeft: e ? e.activeLabel : '' }) }
	          onMouseMove = { (e) => this.state.refAreaLeft && this.setState({refAreaRight: e ? e.activeLabel : '' }) }
	          onMouseUp = { this.zoom } >
	          <CartesianGrid strokeDasharray="3 3"/>
	          <XAxis allowDataOverflow={true} dataKey="day" domain={[left, right]} type="number" />
	          <YAxis allowDataOverflow={true} domain={[bottom, top]} type="number" yAxisId="1" />
	          <Tooltip/>
	          {
	        	  this.state.units.map((unit) => {
	        		  i++;
					  return (<Line key={unit} yAxisId="1" type='natural' dataKey={'val' + i} name={unit} animationDuration={300} stroke={colors[i-1]}/>);
				  })
			  }
	          <Legend />
	          <Brush/>
	          {
	          	(refAreaLeft && refAreaRight) ? (
	            <ReferenceArea yAxisId="1" x1={refAreaLeft} x2={refAreaRight}  strokeOpacity={0.3} /> ) : null
	          }
	        </LineChart>
	        :
	        <p>No hay datos!</p>
	        )
		}
		</div>
	  );
    }
    
    renderEventSecChart() {
	  const data = [
	    { event: 'Exceso de velocidad', val1: 80, val2: 60, fullMark: 100 },
	    { event: 'Aceleración brusca', val1: 98, val2: 80, fullMark: 100 },
	    { event: 'Frenada brusca', val1: 86, val2: 80, fullMark: 100 },
	    { event: 'Curva brusca', val1: 79, val2: 100, fullMark: 100 },
	    { event: 'Giro y aceleración', val1: 85, val2: 90, fullMark: 100 },
	    { event: 'Giro y freno', val1: 65, val2: 85, fullMark: 100 },
	    { event: 'Fuera de caminno', val1: 65, val2: 85, fullMark: 100 }
	  ];
	  let i = 0;
  	  return (
	    <div>
    	  <p>Repartición de eventos de seguridad</p>
    	  {
  			this.state.isLoadingEventSec ?
  			<div><Glyphicon glyph="refresh" className="spinning" />Cargando datos... por favor espere</div>
  			:
  			(
	  	    <RadarChart cx={300} cy={250} outerRadius={100} width={600} height={500} data={data}>
              <PolarGrid />
              <PolarAngleAxis dataKey="event" />
              <PolarRadiusAxis angle={30} domain={[0, 100]}/>
              {
	        	  this.state.units.map((unit) => {
	        		  i++;
	        		  return (<Radar key={unit} name={unit} dataKey={'val' + i} stroke={colors[i-1]} fillOpacity={0.1}/>);
				  })
			  }
              <Legend />
            </RadarChart>
            )
    	  }
        </div>
      );
    }

    render() {
	  return (
		<div>
		<ListGroup>
		  <ListGroupItem key='title'><b>Vehículos seleccionados</b></ListGroupItem>
		  {
			  this.state.units.map((unit) => {
				  return (<ListGroupItem key={unit}>{unit}</ListGroupItem>);
			  })
		  }
		</ListGroup>
		{ this.renderSecChart() }
		{ this.renderEventSecChart() }
        </div>
      );
    }
}


// WEBPACK FOOTER //
// ./src/containers/trip/CompareUnits.js